import classes from "./Slideshow.module.css";
import {Fragment, useEffect, useMemo, useState} from "react";
import arr from "../../store/arr.png"
import arr1 from "../../store/arrow.png"
import log from "../../store/logo.png"
import axios from "axios";
import { path, assetsBaseUrl } from "../../routes";
import Totem_record from "./Totem_record";
import logo from "../../store/logo.png";

const SlideshowTotem = (props) => {

    const [loadedSlides, setLoadedSlides] = useState(props.slideshow)
    const [currentIndexA, setCurrentIndexA] = useState(0);
    const [currentIndexB, setCurrentIndexB] = useState(0);
    const [currentIndexO, setCurrentIndexO] = useState(0);
    const [roomsABCD, setroomsABCD] = useState(props.slideshowAD);
    const [roomsEF, setroomsEF] = useState(props.slideshowEF);
    const [roomsO, setroomsO] = useState(props.slideshowO);
    const [roomsABCDroom, setroomsABCDroom] = useState(props.adroom);
    const [roomsEFroom, setroomsEFroom] = useState(props.efroom);
    const [roomsOroom, setroomsOroom] = useState(props.oroom);
    const [defaultABCD, setDefaultABCD] = useState(props.defA);
    const [defaultEF, setDefaultEF] = useState(props.defB);
    const [kioskSlidesAD, setKioskSlidesAD] = useState(props.kioskSlidesAD || []);
    const [kioskSlidesEF, setKioskSlidesEF] = useState(props.kioskSlidesEF || []);
    const [kioskSlidesO, setKioskSlidesO] = useState(props.kioskSlidesO || []);
    const [isArrow, setIsArrow] = useState(true);
    const [actTime, setActTime] = useState('--:--');
    const [actDate, setActDate] = useState('');
    // Holiday Inn totem: pokud API vrátí nějaké meetingy, nechceme zobrazovat dvojici default obrázků jako "no meeting"
    const [hasMeetingsNow, setHasMeetingsNow] = useState(false);
    /** ?id=11: rotace slideshow v klidu (kiosk + default) */
    const [display11IdleIdx, setDisplay11IdleIdx] = useState(0);

    //console.log(props.slideshowAD)
    // console.log(props.slideshowEF)
    const getTime = () => {
        const now = new Date();

        // Získání jednotlivých částí data
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Měsíce jsou indexovány od 0
        const day = String(now.getDate()).padStart(2, '0');

        // Získání jednotlivých částí času
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');

        // Sestavení výsledného řetězce
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    }

    const parseApiDate = (value) => {
        if (!value) return null;
        if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
        const raw = String(value).trim();
        if (!raw) return null;
        const clean = raw
            .replace('T', ' ')
            .replace(/\.\d+$/, '')
            .replace(/[+-]\d{2}:?\d{2}$/, '')
            .replace(/Z$/, '');
        const [datePart, timePart] = clean.split(' ');
        if (!datePart || !timePart) return null;
        const [yStr, mStr, dStr] = datePart.split('-');
        const [hStr, minStr, secStr] = timePart.split(':');
        const y = Number(yStr);
        const m = Number(mStr);
        const d = Number(dStr);
        const h = Number(hStr);
        const min = Number(minStr);
        const sec = Number(secStr || 0);
        if (![y, m, d, h, min, sec].every((n) => Number.isFinite(n))) return null;
        const parsed = new Date(y, m - 1, d, h, min, sec);
        return Number.isNaN(parsed.getTime()) ? null : parsed;
    };

    const filterActiveMeetingsNow = (rows) => {
        if (!Array.isArray(rows)) return [];
        const now = new Date();
        return rows.filter((row) => {
            const from = parseApiDate(row?.dateFrom || row?.DateFrom || row?.date_from);
            const to = parseApiDate(row?.dateTo || row?.DateTo || row?.date_to);
            // Pokud backend nepošle časy, neblokujeme záznam (fallback na backend).
            if (!from || !to) return true;
            return from <= now && now < to;
        });
    };

    // Legacy scenario/debug helpers removed – rendering is now derived directly from live arrays.

    useEffect(() => {

        const intervalIdCh = setInterval(() => {
            setIsArrow(prevIsArrow => {
                const newIsArrow = !prevIsArrow;
                //console.log(newIsArrow);
                return newIsArrow;
            });
        }, 10000);

        const intervalId = setInterval(() => {
            // ?id=11 v klidu má vlastní rotaci (merged kiosk) – neposouvat index A zde
            const is11 = String(props.displayId ?? '') === '11';
            const id11Idle =
                is11 &&
                roomsABCD.length === 0 &&
                roomsEF.length === 0 &&
                roomsO.length === 0;
            if (id11Idle) return;
            // Použít meeting room záznamy pokud existují, jinak kiosk slides
            const maxA = roomsABCD.length > 0 ? roomsABCD.length : kioskSlidesAD.length;
            const maxB = roomsEF.length > 0 ? roomsEF.length : kioskSlidesEF.length;
            const maxO = roomsO.length > 0 ? roomsO.length : kioskSlidesO.length;
            if (maxA > 0) setCurrentIndexA((prevIndex) => (prevIndex + 1) % maxA);
            if (maxB > 0) setCurrentIndexB((prevIndex) => (prevIndex + 1) % maxB);
            if (maxO > 0) setCurrentIndexO((prevIndex) => (prevIndex + 1) % maxO);
        }, 5000);

        //console.log(loadedSlides)
        const getDefaultSlides = async () => {
            let tmpA = []
            let tmpB = []
            let response = await axios.get(`${path}/getDefaultScreen`);
            //console.log(response.data)
            for (let i = 0; i < response.data.length; i++) {
                if (response.data[i].id == 1) {
                    tmpA.push(assetsBaseUrl + response.data[i].path)
                }
                if (response.data[i].id == 2) {
                    tmpB.push(assetsBaseUrl + response.data[i].path)
                }
            }
            setDefaultABCD([...tmpA])
            setDefaultEF([...tmpB])
        }

        const getRecords = async () => {
            await getDefaultSlides();
            let response;
            try {
                const fallbackOrgId = "E15F8010-B7EB-4526-A985-F00D517EBF4C";
                const liveOrgId = props.orgId || fallbackOrgId;
                response = await axios.get(`${path}/getRecordsNowV2?orgID=${encodeURIComponent(liveOrgId)}&day=${encodeURIComponent(getTime())}&_t=${Date.now()}`);
                if (Array.isArray(response?.data)) {
                    const data = filterActiveMeetingsNow(response.data);
                    setHasMeetingsNow(data.length > 0);
                    // Vždy přepsat i prázdný stav, aby displej "nezůstal zaseklý" na starých room obrázcích.
                    if (data.length === 0) {
                        setObjetotem([]);
                    } else {
                        setObjetotem(data);
                    }
                } else {
                    setHasMeetingsNow(false);
                    // Pokud backend vrátí neočekávaný formát / dojde chyba, vyčistit zobrazení.
                    setObjetotem([]);
                }
            } catch (error) {
                // Pokud se meeting data nepodaří načíst, nesmí displej zůstat "zaseknutý" na starých obrázcích.
                setHasMeetingsNow(false);
                setObjetotem([]);
            }
        }

        const setObjetotem = (x) => {
            if (!Array.isArray(x)) return;
            let fldAD = []
            let fldEF = []
            let fldO = []
            let fldADroom = []
            let fldEFroom = []
            let fldOroom = []
            const getRoomName = (item) => {
                const rd = String(item?.roomDescription || '').trim();
                const room = String(item?.room || '').trim();
                const rdNorm = rd.replace(/\s+/g, '').toUpperCase(); // "A - D" -> "A-D"

                const extractLetter = (allowed) => {
                    if (!room) return null;
                    const r = room.toUpperCase();
                    // Meeting Room C / Room C
                    const m1 = r.match(new RegExp(`MEETING\\s*ROOM\\s*([${allowed}])\\b`));
                    if (m1?.[1]) return m1[1];
                    const m2 = r.match(new RegExp(`\\bROOM\\s*([${allowed}])\\b`));
                    if (m2?.[1]) return m2[1];
                    // fallback: single-letter token
                    const m3 = r.match(new RegExp(`\\b([${allowed}])\\b`));
                    if (m3?.[1]) return m3[1];
                    return null;
                };

                // Pokud je roomDescription jen obecná skupina (A-D / E-F), z room stringu vyber konkrétní písmeno.
                if (rdNorm === 'A-D') {
                    return extractLetter('ABCD') || rd;
                }
                if (rdNorm === 'E-F') {
                    return extractLetter('EF') || rd;
                }

                if (rd) return rd;
                if (room && room.length > 13) return room.substring(13);
                return room || '';
            };
            const isADGroup = (row) => {
                if (row.cRoomGroup_id == 1) return true;
                const rd = (row.roomDescription || '').toUpperCase();
                const room = (row.room || '').toUpperCase();
                if (rd === 'A-D' || rd === 'A - D') return true;
                if (/MEETING ROOM [ABCD]\b/.test(room) || /\b(ROOM )?[ABCD]\b/.test(room)) return true;
                return false;
            };
            const isEFGroup = (row) => {
                if (row.cRoomGroup_id == 3) return true;
                const rd = (row.roomDescription || '').toUpperCase();
                const room = (row.room || '').toUpperCase();
                if (rd === 'E-F' || rd === 'E - F') return true;
                if (/MEETING ROOM [EF]\b/.test(room) || /\b(ROOM )?[EF]\b/.test(room)) return true;
                return false;
            };
            for (let i = 0; i < x.length; i++) {
                const row = x[i];
                if (isADGroup(row)) {
                    fldAD.push(assetsBaseUrl + (row.path || '').replace(/\\/g, '/'));
                    fldADroom.push(getRoomName(row));
                }
                if (isEFGroup(row)) {
                    fldEF.push(assetsBaseUrl + (row.path || '').replace(/\\/g, '/'));
                    fldEFroom.push(getRoomName(row));
                }
                if (row.cRoomGroup_id == 10) {
                    fldO.push(assetsBaseUrl + (row.path || '').replace(/\\/g, '/'));
                    fldOroom.push(getRoomName(row));
                }
            }
            //console.log(fldAD, fldEF)
            setCurrentIndexA(0)
            setCurrentIndexB(0)
            setCurrentIndexO(0)
            setroomsABCD([...fldAD])
            setroomsEF([...fldEF])
            setroomsO([...fldO])
            setroomsABCDroom([...fldADroom])
            setroomsEFroom([...fldEFroom])
            setroomsOroom([...fldOroom])
            //console.log("",currentIndexA,currentIndexB,fldAD,fldEF,fldAD.length,fldEF.length)
            //debugger;
        }


        // meeting data mohou začít/zmizet mezi refresh cykly → kratší polling, aby se displeje samy updatly
        const intervalId3 = setInterval(getRecords, 20 * 1000);

        return () => {
            clearInterval(intervalId);
            clearInterval(intervalId3);
            clearInterval(intervalIdCh);
        };
    }, [roomsABCD, roomsEF, roomsABCDroom, roomsEFroom, kioskSlidesAD, kioskSlidesEF, kioskSlidesO, props.displayId]);

    // Synchronizace meeting dat z MainJS – když rodič pošle data (id=3, id=11 bez room, id=12 Holiday Inn),
    // totem musí zobrazit „kde“ a „jakým směrem“; bez této synchronizace by zůstal prázdný stav.
    useEffect(() => {
        const ad = Array.isArray(props.slideshowAD) ? props.slideshowAD : [];
        const ef = Array.isArray(props.slideshowEF) ? props.slideshowEF : [];
        const o = Array.isArray(props.slideshowO) ? props.slideshowO : [];
        const adRoom = Array.isArray(props.adroom) ? props.adroom : [];
        const efRoom = Array.isArray(props.efroom) ? props.efroom : [];
        const oRoom = Array.isArray(props.oroom) ? props.oroom : [];
        if (ad.length > 0 || ef.length > 0 || o.length > 0) {
            setroomsABCD(ad);
            setroomsEF(ef);
            setroomsO(o);
            setroomsABCDroom(adRoom);
            setroomsEFroom(efRoom);
            setroomsOroom(oRoom);
            setCurrentIndexA(0);
            setCurrentIndexB(0);
            setCurrentIndexO(0);
            setHasMeetingsNow(true);
        } else {
            // Meeting už není aktivní → vyčistit stale zobrazené roomy.
            setroomsABCD([]);
            setroomsEF([]);
            setroomsO([]);
            setroomsABCDroom([]);
            setroomsEFroom([]);
            setroomsOroom([]);
            setCurrentIndexA(0);
            setCurrentIndexB(0);
            setCurrentIndexO(0);
            setHasMeetingsNow(false);
        }
    }, [props.slideshowAD, props.slideshowEF, props.slideshowO, props.adroom, props.efroom, props.oroom]);

    // Synchronizace default obrázků (Top/Bottom) z rodiče – aby se obrázky zobrazily i při ?id=3&orgID=...
    useEffect(() => {
        const defA = Array.isArray(props.defA) ? props.defA : [];
        const defB = Array.isArray(props.defB) ? props.defB : [];
        if (defA.length > 0 || defB.length > 0) {
            setDefaultABCD(defA);
            setDefaultEF(defB);
        }
    }, [props.defA, props.defB]);

    // Aktualizovat kiosk slides když se props změní
    useEffect(() => {
        setKioskSlidesAD(props.kioskSlidesAD || []);
        setKioskSlidesEF(props.kioskSlidesEF || []);
        setKioskSlidesO(props.kioskSlidesO || []);
        // Resetovat indexy když se změní kiosk slides
        if (props.kioskSlidesAD && props.kioskSlidesAD.length > 0 && roomsABCD.length === 0) {
            setCurrentIndexA(0);
        }
        if (props.kioskSlidesEF && props.kioskSlidesEF.length > 0 && roomsEF.length === 0) {
            setCurrentIndexB(0);
        }
        if (props.kioskSlidesO && props.kioskSlidesO.length > 0 && roomsO.length === 0) {
            setCurrentIndexO(0);
        }
    }, [props.kioskSlidesAD, props.kioskSlidesEF, props.kioskSlidesO, roomsABCD.length, roomsEF.length, roomsO.length]);

    useEffect(() => {
        const resetVal = async () => {
            let rs
            rs = await axios.post(`${path}/updateReset/29`)
        }
        const getReset = async () => {
            console.warn("reset_call")
            try {
                let response
                response = await axios.get(`${path}/getReset/29`);
                //console.log(response.data[0].needUpdate);
                if (response.data[0].needUpdate === 1) {
                    // console.log("update")
                    resetVal()
                    console.log(`FE_refresh needed: ${response.data[0].needUpdate === 1 ? "YES" : "NO"}`)
                    window.location.reload();

                } else {
                    //setneedUpdate(0)
                    console.log(`FE_refresh needed: ${response.data[0].needUpdate === 1 ? "YES" : "NO"}`)
                }
            } catch (error) {

            }
        }
        const intervalId5 = setInterval(getReset, 60 * 2 * 1000);
        return () => {
            clearInterval(intervalId5);
        };
    }, [])


    // Hodiny a datum – aktualizace každou sekundu
    useEffect(() => {
        const updateTime = () => {
            const dt = new Date();
            setActTime(`${String(dt.getHours()).padStart(2, '0')}:${String(dt.getMinutes()).padStart(2, '0')}`);
            setActDate(`${String(dt.getDate()).padStart(2, '0')}. ${String(dt.getMonth() + 1).padStart(2, '0')}. ${dt.getFullYear()}`);
        };
        updateTime();
        const intervalId = setInterval(updateTime, 1000);
        return () => clearInterval(intervalId);
    }, [])

    /** ?id=11 bez meetingů: sloučené obrázky ze všech kiosk skupin (+ default), pro rotaci na celé ploše */
    const id11MergedIdleList = useMemo(() => {
        const did = props.displayId == null ? '' : String(props.displayId);
        if (did !== '11') return null;
        const hasRows = roomsABCD.length > 0 || roomsEF.length > 0 || roomsO.length > 0;
        if (hasRows) return null;
        const merged = [
            ...new Set([...(kioskSlidesAD || []), ...(kioskSlidesEF || []), ...(kioskSlidesO || [])]),
        ];
        if (merged.length > 0) return merged;
        if (defaultABCD.length > 0) return [...defaultABCD];
        return [logo];
    }, [
        props.displayId,
        roomsABCD.length,
        roomsEF.length,
        roomsO.length,
        kioskSlidesAD,
        kioskSlidesEF,
        kioskSlidesO,
        defaultABCD,
    ]);

    const id11MergedIdleKey =
        id11MergedIdleList == null ? '' : id11MergedIdleList.join('|');

    useEffect(() => {
        setDisplay11IdleIdx(0);
    }, [id11MergedIdleKey]);

    useEffect(() => {
        if (!id11MergedIdleList || id11MergedIdleList.length <= 1) return;
        const n = id11MergedIdleList.length;
        const id = setInterval(() => {
            setDisplay11IdleIdx((p) => (p + 1) % n);
        }, 5000);
        return () => clearInterval(id);
    }, [id11MergedIdleList]);

    const isDisplay12 = String(props.displayId ?? '') === '12';

    let arrowLeftUp = (<Fragment>
            <img
                src={arr}
                alt={`arrow1`}
                className={`${classes.slideImageT} ${isDisplay12 ? '' : classes.slideImageTUp}`}
            />
            <label>MEETING ROOM A-D</label>
            {!isDisplay12 && <label>1. PATRO / 1ST FLOOR</label>}
        </Fragment>
    )
    let arrowLeft = (<Fragment>
            <img
                src={arr}
                alt={`arrow1`}
                className={`${classes.slideImageT}`}
            />
            <label>MEETING ROOM E+F</label>
            <label>PŘÍZEMÍ / GROUND FLOOR</label>
        </Fragment>
    )


    let SlideShow_Totem = (<div className={classes.slideTot}>
        <div className={classes.box}>
            {isArrow == true ? arrowLeftUp : roomsABCD.length != 0 ? <img
                src={roomsABCD[currentIndexA]}
                alt={`Slide ${currentIndexA + 1}`}
                className={`${classes.slideImageT} `}
            /> : arrowLeftUp}
        </div>
        <hr className={classes.line}/>
        <div className={classes.box}>
            {isArrow == true ? arrowLeft : roomsEF.length != 0 ? <img
                src={roomsEF[currentIndexB]}
                alt={`Slide ${currentIndexB + 1}`}
                className={`${classes.slideImageT} `}
            /> : arrowLeft}
        </div>
    </div>)

    let ts1 = (<div className={classes.slideTot}>
        <div className={classes.box}>
            {arrowLeft}
        </div>
        <hr className={classes.line}/>
        <div className={classes.box}>
            {<img
                src={roomsEF[currentIndexB]}
                alt={`Slide ${currentIndexB + 1}`}
                className={`${classes.slideImageT} `}
            />}
        </div>
    </div>)

    let ts3A = (<div className={classes.slideTot}>
        <div className={classes.box}>
            {arrowLeftUp}
        </div>
        <hr className={classes.line}/>
        <div className={classes.box}>
            {arrowLeft}
        </div>
    </div>)
    let ts3 = (<div className={classes.slideTot}>
        <div className={classes.boxT}>
            {defaultABCD.length === 0 ? arrowLeftUp : <img
                src={defaultABCD[0]}
                alt={`Slide ${1}`}
                className={`${classes.slideImageTF} `}
            />}
        </div>
        <hr className={classes.line}/>
        <div className={classes.boxE}>
            {defaultEF.length === 0 ? arrowLeft : <img
                src={defaultEF[0]}
                alt={`Slide ${1}`}
                className={`${classes.slideImageTF} `}
            />}
        </div>
    </div>)
    let ts2 = (<div className={classes.slideTot}>
        <div className={classes.box}>
            {arrowLeftUp}
        </div>
        <hr className={classes.line}/>
        <div className={classes.box}>
            {<img
                src={roomsABCD[currentIndexA]}
                alt={`Slide ${currentIndexA + 1}`}
                className={`${classes.slideImageT} `}
            />}
        </div>
    </div>)
    /*
    *
    *   LEVEL
    *       0 - Přízemí
    *       1 - 1. patro
    *   ROOM
    *       any - format "Meeting room A"
    *   PATH
    *       any
    * */
    // Určit, které obrázky použít (priorita: meeting room záznamy > default screen > kiosk slides)
    const useMeetingRoomsAD = roomsABCD.length > 0;
    const useMeetingRoomsEF = roomsEF.length > 0;
    const useMeetingRoomsO = roomsO.length > 0;
    
    // Pro totem bez meetingů: default screen má prioritu před kiosk slides
    const imagesAD = roomsABCD.length > 0 
        ? roomsABCD 
        : (defaultABCD.length > 0 ? defaultABCD : kioskSlidesAD);
    const imagesEF = roomsEF.length > 0 
        ? roomsEF 
        : (defaultEF.length > 0 ? defaultEF : kioskSlidesEF);
    const imagesO = roomsO.length > 0 
        ? roomsO 
        : (kioskSlidesO.length > 0 ? kioskSlidesO : []);
    
    // Zajistit správné indexování
    const safeIndexA = imagesAD.length > 0 ? (currentIndexA % imagesAD.length) : 0;
    const safeIndexB = imagesEF.length > 0 ? (currentIndexB % imagesEF.length) : 0;
    const safeIndexO = imagesO.length > 0 ? (currentIndexO % imagesO.length) : 0;
    
    // Režim s meetingy: popup s šipkami, směrem a názvy místností.
    let recO = <div className={classes.mainbox}>
        <div className={classes.arrowbox}>
            <img className={classes.Up} src={arr1} alt="logo"/>
            <p>{`Konferenční místnost  Meeting room`}</p>
            <div className={classes.bigCharOR}>{roomsOroom.length > safeIndexO ? roomsOroom[safeIndexO] : ''}</div>
            <p>{"Přízemí | Ground floor"}</p>
        </div>
        <div className={classes.logobox}>
        <img src={imagesO.length > 0 ? imagesO[safeIndexO] : logo} alt="logo"/>
        </div>
    </div>
    // Holiday Inn recepce (?id=3): nahoře 1 obrázek, dole navigace + obrázek vpravo (jako původní recA/recB/recO)
    let recA = <div className={classes.mainbox}>
        <div className={classes.arrowbox}>
            <img className={isDisplay12 ? classes.left : classes.leftUp} src={arr1} alt="logo"/>
            <p>{`Konferenční místnost  Meeting room`}</p>
            <div className={classes.bigChar}>{roomsABCDroom.length > safeIndexA ? roomsABCDroom[safeIndexA] : ''}</div>
            {!isDisplay12 && <p>{"1. patro | 1st floor"}</p>}
        </div>
        <div className={classes.logobox}>
            <img src={imagesAD.length > 0 ? imagesAD[safeIndexA] : (defaultABCD[0] || logo)} alt="logo"/>
        </div>
    </div>
    let recB = <div className={classes.mainbox}>
        <div className={classes.arrowbox}>
            <img className={classes.left} src={arr1} alt="logo"/>
            <p>{`Konferenční místnost  Meeting room`}</p>
            <div className={classes.bigChar}>{roomsEFroom.length > safeIndexB ? roomsEFroom[safeIndexB] : ''}</div>
            <p>{"Přízemí | Ground floor"}</p>
        </div>
        <div className={classes.logobox}>
        <img src={imagesEF.length > 0 ? imagesEF[safeIndexB] : (defaultEF[0] || logo)} alt="logo"/>
        </div>
    </div>
    const holidayInnRoute = (group, imgSrc) => {
        if (group === 'O') {
            return (
                <div className={classes.mainbox}>
                    <div className={classes.arrowbox}>
                        <img className={classes.Up} src={arr1} alt="logo"/>
                        <p>{`Konferenční místnost  Meeting room`}</p>
                        <div className={classes.bigCharOR}>{roomsOroom.length > safeIndexO ? roomsOroom[safeIndexO] : ''}</div>
                        <p>{"Přízemí | Ground floor"}</p>
                    </div>
                    <div className={classes.logobox}>
                        <img src={imgSrc || logo} alt="logo"/>
                    </div>
                </div>
            );
        }
        if (group === 'EF') {
            return (
                <div className={classes.mainbox}>
                    <div className={classes.arrowbox}>
                        <img className={classes.left} src={arr1} alt="logo"/>
                        <p>{`Konferenční místnost  Meeting room`}</p>
                        <div className={classes.bigChar}>{roomsEFroom.length > safeIndexB ? roomsEFroom[safeIndexB] : ''}</div>
                        <p>{"Přízemí | Ground floor"}</p>
                    </div>
                    <div className={classes.logobox}>
                        <img src={imgSrc || logo} alt="logo"/>
                    </div>
                </div>
            );
        }
        // default: AD
        return (
            <div className={classes.mainbox}>
                <div className={classes.arrowbox}>
                    <img className={isDisplay12 ? classes.left : classes.leftUp} src={arr1} alt="logo"/>
                    <p>{`Konferenční místnost  Meeting room`}</p>
                    <div className={classes.bigChar}>{roomsABCDroom.length > safeIndexA ? roomsABCDroom[safeIndexA] : ''}</div>
                    {!isDisplay12 && <p>{"1. patro | 1st floor"}</p>}
                </div>
                <div className={classes.logobox}>
                    <img src={imgSrc || logo} alt="logo"/>
                </div>
            </div>
        );
    };

    /** ?id=12 více meetingů A–D: stejný obsah jako recA, ale pro konkrétní řádek (index místnosti). */
    const renderHallwayADMeetingRow = (imgSrc, roomIdx) => (
        <div className={`${classes.mainbox} ${classes.hallwayMeetingMainbox}`}>
            <div className={classes.arrowbox}>
                <img className={isDisplay12 ? classes.left : classes.leftUp} src={arr1} alt="logo"/>
                <p>{`Konferenční místnost  Meeting room`}</p>
                <div className={classes.bigChar}>{roomsABCDroom.length > roomIdx ? roomsABCDroom[roomIdx] : ''}</div>
                {!isDisplay12 && <p>{"1. patro | 1st floor"}</p>}
            </div>
            <div className={classes.logobox}>
                <img src={imgSrc || logo} alt="logo"/>
            </div>
        </div>
    );

    const renderHallwayEFMeetingRow = (imgSrc, roomIdx) => (
        <div className={`${classes.mainbox} ${classes.hallwayMeetingMainbox}`}>
            <div className={classes.arrowbox}>
                <img className={classes.left} src={arr1} alt="logo"/>
                <p>{`Konferenční místnost  Meeting room`}</p>
                <div className={classes.bigChar}>{roomsEFroom.length > roomIdx ? roomsEFroom[roomIdx] : ''}</div>
                <p>{"Přízemí | Ground floor"}</p>
            </div>
            <div className={classes.logobox}>
                <img src={imgSrc || logo} alt="logo"/>
            </div>
        </div>
    );

    const renderHallwayOMeetingRow = (imgSrc, roomIdx) => (
        <div className={`${classes.mainbox} ${classes.hallwayMeetingMainbox}`}>
            <div className={classes.arrowbox}>
                <img className={classes.Up} src={arr1} alt="logo"/>
                <p>{`Konferenční místnost  Meeting room`}</p>
                <div className={classes.bigCharOR}>{roomsOroom.length > roomIdx ? roomsOroom[roomIdx] : ''}</div>
                <p>{"Přízemí | Ground floor"}</p>
            </div>
            <div className={classes.logobox}>
                <img src={imgSrc || logo} alt="logo"/>
            </div>
        </div>
    );
    
    // Režim bez meetingů:
    // 1) Pokud máme dvojici default screen (Top+Bottom), použij ji vždy.
    // 2) Jinak použij obrázky z Kiosk Slideshow (první nahoře, druhý dole).
    // Pokud API vrátilo meetingy, nechceme spadnout do "no meeting" jen kvůli tomu,
    // že se meeting nepodařilo zařadit do skupin A-D/E-F/O.
    const noMeetingMode = !hasMeetingsNow && !useMeetingRoomsAD && !useMeetingRoomsEF && !useMeetingRoomsO;
    const useDefaultPair = noMeetingMode && defaultABCD.length > 0 && defaultEF.length > 0;
    const recepceSlides = noMeetingMode && !useDefaultPair
        ? (imagesAD.length > 0 ? imagesAD : imagesEF)
        : [];
    const topImg = useDefaultPair
        ? (defaultABCD[0] || logo)
        : recepceSlides[0];
    const bottomImg = useDefaultPair
        ? (defaultEF[0] || logo)
        : (recepceSlides.length >= 2 ? recepceSlides[1] : recepceSlides[0]);
    
    const simpleImgO = imagesO.length > 0 && <img src={imagesO[safeIndexO]} alt="" className={`${classes.slideImageTF} `} />;
    const simpleImgA = imagesAD.length > 0 && <img src={imagesAD[safeIndexA]} alt="" className={`${classes.slideImageTF} `} />;
    const simpleImgB = imagesEF.length > 0 && <img src={imagesEF[safeIndexB]} alt="" className={`${classes.slideImageTF} `} />;
    
    // Dva boxy (nahoře / dole) z Kiosk Slideshow: první obrázek nahoře, druhý dole
    const recepceTopImg = topImg && <img src={topImg} alt="" className={`${classes.slideImageTF} `} />;
    const recepceBottomImg = bottomImg && <img src={bottomImg} alt="" className={`${classes.slideImageTF} `} />;

    const hasMeeting = useMeetingRoomsAD || useMeetingRoomsEF || useMeetingRoomsO;
    const displayId = props.displayId == null ? undefined : String(props.displayId);
    const MAX_STACK_ROWS = 4;
    const isSingleImageDisplay = displayId === '12';  // ?id=12 → chodba 1. patro (Holiday Inn)
    /** Počet meetingů ve skupině A–D (1. patro) – pro ?id=12 layout */
    const adMeetingCount = roomsABCD.length;
    const isHolidayInnReception = displayId === '3';  // ?id=3 → nahoře 1 obrázek, dole jen navigace
    const showTimeInHeader = displayId !== '3';     // ?id=3 → bez času nahoře
    const isDisplay11 = displayId === '11';
    /** Aktivní meeting řádky (A–D / E–F / O) – ?id=3 recepce i ?id=11 totem */
    const hasRowMeetings =
        useMeetingRoomsAD || useMeetingRoomsEF || useMeetingRoomsO;
    const [meetingStackPage, setMeetingStackPage] = useState(0);
    const [hallway12Page, setHallway12Page] = useState(0);
    const [hallway12IdleIdx, setHallway12IdleIdx] = useState(0);
    /** ?id=3 / ?id=12: při jednom meetingu – rotace default obrázků nahoře */
    const [totemSingleTopIdx, setTotemSingleTopIdx] = useState(0);
    const id11IdleImgSrc =
        id11MergedIdleList && id11MergedIdleList.length > 0
            ? id11MergedIdleList[display11IdleIdx % id11MergedIdleList.length]
            : defaultABCD[0] || logo;

    const [holidayInnReceptionActiveGroup, setHolidayInnReceptionActiveGroup] = useState(null);
    useEffect(() => {
        if (!isHolidayInnReception) return;
        // Více meetingů = vertikální stack; rotace jedné skupiny už nepoužíváme
        if (hasRowMeetings) {
            setHolidayInnReceptionActiveGroup(null);
            return;
        }

        const candidates = [];
        if (useMeetingRoomsAD) candidates.push('AD');
        if (useMeetingRoomsEF) candidates.push('EF');
        if (useMeetingRoomsO) candidates.push('O');

        if (!candidates.length) {
            setHolidayInnReceptionActiveGroup(null);
            return;
        }

        let idx = 0;
        setHolidayInnReceptionActiveGroup(candidates[idx]);
        const interval = setInterval(() => {
            idx = (idx + 1) % candidates.length;
            setHolidayInnReceptionActiveGroup(candidates[idx]);
        }, 10000);

        return () => clearInterval(interval);
    }, [isHolidayInnReception, hasRowMeetings, useMeetingRoomsAD, useMeetingRoomsEF, useMeetingRoomsO]);

    const activeMeetingGroup = isHolidayInnReception
        ? (holidayInnReceptionActiveGroup || (useMeetingRoomsO ? 'O' : (useMeetingRoomsAD ? 'AD' : (useMeetingRoomsEF ? 'EF' : null))))
        : (useMeetingRoomsO ? 'O' : (useMeetingRoomsAD ? 'AD' : (useMeetingRoomsEF ? 'EF' : null)));
    const activeTopImage = noMeetingMode
        ? (topImg || defaultABCD[0] || logo)
        : (activeMeetingGroup === 'O'
            ? (imagesO.length > 0 ? imagesO[safeIndexO] : (topImg || defaultABCD[0] || logo))
            : (activeMeetingGroup === 'EF'
                ? (imagesEF.length > 0 ? imagesEF[safeIndexB] : (topImg || defaultABCD[0] || logo))
                : (imagesAD.length > 0 ? imagesAD[safeIndexA] : (topImg || defaultABCD[0] || logo))));
    const activeRoute = holidayInnRoute(activeMeetingGroup, activeTopImage);
    
    let ts66 = (<div className={classes.slideTot}>

        {(!noMeetingMode && imagesO.length > 0) && <>
            <div className={classes.boxT}>
                {useMeetingRoomsO ? recO : simpleImgO}
            </div>
            {/* ?id=3: nechceme dvě čáry, necháme jen tu uprostřed */}
            {!isHolidayInnReception && <hr className={classes.line}/>}
        </>
        }
        <div className={classes.boxT}>
            {isHolidayInnReception ? (
                // ?id=3: při meetingu nechceme nahoře full-width logo/obrázek (logo je už dole vedle šipky)
                (noMeetingMode ? (
                    <img
                        src={activeTopImage}
                        alt=""
                        className={`${classes.slideImageTF} `}
                    />
                ) : null)
            ) : (
                <>
                    {noMeetingMode && topImg && recepceTopImg}
                    {noMeetingMode && !topImg && <img src={defaultABCD[0] || logo} alt="" className={`${classes.slideImageTF} `} />}
                    {!noMeetingMode && imagesAD.length > 0 && (useMeetingRoomsAD ? recA : simpleImgA)}
                    {/* Meeting režim bez fotek: neukazuj default screen, ukaž šipku */} 
                    {!noMeetingMode && imagesAD.length == 0 && arrowLeftUp}
                </>
            )}
        </div>
        <hr className={classes.line}/>
        <div className={classes.boxE}>
            {isHolidayInnReception ? (
                // Holiday Inn recepce (?id=3): při no-meeting musí být vidět i "bottom" fotka.
                noMeetingMode ? (
                    <img
                        src={bottomImg}
                        alt=""
                        className={`${classes.slideImageTF} `}
                    />
                ) : (!noMeetingMode && hasMeeting ? activeRoute : null)
            ) : (
                <>
                    {noMeetingMode && bottomImg && recepceBottomImg}
                    {noMeetingMode && !bottomImg && <img src={defaultEF[0] || logo} alt="" className={`${classes.slideImageTF} `} />}
                    {!noMeetingMode && imagesEF.length > 0 && (useMeetingRoomsEF ? recB : simpleImgB)}
                    {/* Meeting režim bez fotek: neukazuj default screen, ukaž šipku */} 
                    {!noMeetingMode && imagesEF.length == 0 && arrowLeft}
                </>
            )}

        </div>
    </div>)

    // ?id=12 chodba 1. patro: stejné texty jako recA (bez „Směr: 1. patro ↗“).
    // Více meetingů A–D: celá obrazovka, řádky pod sebou. Default „Recepce“ jen při 0 nebo 1 meetingu ve skupině A–D.
    const hallwayAllowDefaultImage =
        noMeetingMode || !useMeetingRoomsAD || adMeetingCount <= 1;

    const meetingStackRows = [];
    if (useMeetingRoomsO) {
        imagesO.forEach((src, i) => {
            meetingStackRows.push({
                key: `mstack-o-${i}-${src}`,
                node: renderHallwayOMeetingRow(src, i),
            });
        });
    }
    if (useMeetingRoomsAD) {
        imagesAD.forEach((src, i) => {
            meetingStackRows.push({
                key: `mstack-ad-${i}-${src}`,
                node: renderHallwayADMeetingRow(src, i),
            });
        });
    }
    if (useMeetingRoomsEF) {
        imagesEF.forEach((src, i) => {
            meetingStackRows.push({
                key: `mstack-ef-${i}-${src}`,
                node: renderHallwayEFMeetingRow(src, i),
            });
        });
    }
    const meetingStackPages = Math.max(1, Math.ceil(meetingStackRows.length / MAX_STACK_ROWS));
    const meetingStackPageSafe = meetingStackPages > 0 ? (meetingStackPage % meetingStackPages) : 0;
    const meetingStackRowsVisible = meetingStackRows.slice(
        meetingStackPageSafe * MAX_STACK_ROWS,
        (meetingStackPageSafe + 1) * MAX_STACK_ROWS
    );
    const meetingStackKey = meetingStackRows.map((r) => r.key).join("|");

    useEffect(() => {
        setMeetingStackPage(0);
    }, [meetingStackKey]);

    useEffect(() => {
        if (meetingStackPages <= 1) return;
        const interval = setInterval(() => {
            setMeetingStackPage((prev) => (prev + 1) % meetingStackPages);
        }, 10000);
        return () => clearInterval(interval);
    }, [meetingStackPages]);

    const hallway12Rows = imagesAD.map((src, i) => ({
        key: `hall12-${i}-${src}`,
        node: renderHallwayADMeetingRow(src, i),
    }));
    const hallway12Pages = Math.max(1, Math.ceil(hallway12Rows.length / MAX_STACK_ROWS));
    const hallway12PageSafe = hallway12Pages > 0 ? (hallway12Page % hallway12Pages) : 0;
    const hallway12RowsVisible = hallway12Rows.slice(
        hallway12PageSafe * MAX_STACK_ROWS,
        (hallway12PageSafe + 1) * MAX_STACK_ROWS
    );
    const hallway12Key = hallway12Rows.map((r) => r.key).join("|");

    useEffect(() => {
        setHallway12Page(0);
    }, [hallway12Key]);

    useEffect(() => {
        if (!(useMeetingRoomsAD && adMeetingCount > 1)) return;
        if (hallway12Pages <= 1) return;
        const interval = setInterval(() => {
            setHallway12Page((prev) => (prev + 1) % hallway12Pages);
        }, 10000);
        return () => clearInterval(interval);
    }, [useMeetingRoomsAD, adMeetingCount, hallway12Pages]);

    // ?id=12 bez meetingu: střídat oba default obrázky (A/B), neukazovat jen první.
    const hallway12IdleSlides = useMemo(() => {
        if (!isSingleImageDisplay) return [];
        if (!noMeetingMode) return [];
        const slides = [];
        if (defaultABCD.length > 0 && defaultABCD[0]) slides.push(defaultABCD[0]);
        if (defaultEF.length > 0 && defaultEF[0]) slides.push(defaultEF[0]);
        if (slides.length === 0 && topImg) slides.push(topImg);
        return slides;
    }, [isSingleImageDisplay, noMeetingMode, defaultABCD, defaultEF, topImg]);

    useEffect(() => {
        setHallway12IdleIdx(0);
    }, [hallway12IdleSlides.join("|")]);

    useEffect(() => {
        if (!isSingleImageDisplay || !noMeetingMode) return;
        if (hallway12IdleSlides.length <= 1) return;
        const n = hallway12IdleSlides.length;
        const interval = setInterval(() => {
            setHallway12IdleIdx((prev) => (prev + 1) % n);
        }, 5000);
        return () => clearInterval(interval);
    }, [isSingleImageDisplay, noMeetingMode, hallway12IdleSlides]);

    /** Společný vertikální stack pro ?id=3 (recepce) a ?id=11 při aktivních meetingech */
    const meetingStackContent = (
        <div
            className={`${classes.slideTot} ${classes.singleImageTop} ${classes.hallway12Full}`}
        >
            <div className={classes.hallwayRatio916}>
                <div className={classes.hallwayMeetingsStack}>
                    {meetingStackRowsVisible.map((row) => (
                        <div className={classes.hallwayMeetingRow} key={row.key}>
                            {row.node}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );

    // Default A/B páry nahoře (stejná logika jako ?id=12 idle) – pro jeden aktivní meeting u ?id=3 a ?id=12
    const totemSingleTopSlides = useMemo(() => {
        const slides = [];
        if (defaultABCD.length > 0 && defaultABCD[0]) slides.push(defaultABCD[0]);
        if (defaultEF.length > 0 && defaultEF[0]) slides.push(defaultEF[0]);
        if (slides.length === 0) slides.push(defaultABCD[0] || logo);
        return slides;
    }, [defaultABCD, defaultEF]);

    const totemSingleTopMeetingModeId3 =
        isHolidayInnReception && hasRowMeetings && meetingStackRows.length === 1;
    const totemSingleTopMeetingModeId12 =
        isSingleImageDisplay && useMeetingRoomsAD && adMeetingCount === 1;
    const totemSingleTopMeetingMode =
        totemSingleTopMeetingModeId3 || totemSingleTopMeetingModeId12;

    useEffect(() => {
        setTotemSingleTopIdx(0);
    }, [totemSingleTopSlides.join("|")]);

    useEffect(() => {
        if (!totemSingleTopMeetingMode) return;
        if (totemSingleTopSlides.length <= 1) return;
        const n = totemSingleTopSlides.length;
        const interval = setInterval(() => {
            setTotemSingleTopIdx((prev) => (prev + 1) % n);
        }, 5000);
        return () => clearInterval(interval);
    }, [totemSingleTopMeetingMode, totemSingleTopSlides]);

    const totemSingleTopImgSrc =
        totemSingleTopSlides.length > 0
            ? totemSingleTopSlides[totemSingleTopIdx % totemSingleTopSlides.length]
            : defaultABCD[0] || logo;

    const content = isSingleImageDisplay ? (
        <div
            className={`${classes.slideTot} ${classes.singleImageTop} ${
                useMeetingRoomsAD && adMeetingCount > 1 ? classes.hallway12Full : ''
            }`}
        >
            {useMeetingRoomsAD && adMeetingCount > 1 ? (
                <div className={classes.hallwayRatio916}>
                    <div className={classes.hallwayMeetingsStack}>
                        {hallway12RowsVisible.map((row) => (
                            <div className={classes.hallwayMeetingRow} key={row.key}>
                                {row.node}
                            </div>
                        ))}
                    </div>
                </div>
            ) : totemSingleTopMeetingModeId12 ? (
                <>
                    <div className={`${classes.boxT} ${classes.boxTFullHeight}`}>
                        <img
                            src={totemSingleTopImgSrc}
                            alt=""
                            className={classes.slideImageFixedHeight}
                        />
                    </div>
                    <hr className={classes.line} />
                    <div className={classes.boxE}>
                        <div className={classes.hallwayMeetingRow}>
                            {renderHallwayADMeetingRow(imagesAD[0], 0)}
                        </div>
                    </div>
                </>
            ) : (
                <div
                    className={`${classes.boxT} ${classes.boxTFullHeight}`}
                >
                    {noMeetingMode && (
                        <img
                            src={
                                hallway12IdleSlides.length > 0
                                    ? hallway12IdleSlides[hallway12IdleIdx % hallway12IdleSlides.length]
                                    : (topImg || defaultABCD[0] || logo)
                            }
                            alt=""
                            className={classes.slideImageFixedHeight}
                        />
                    )}
                    {!noMeetingMode && imagesAD.length > 0 && (
                        useMeetingRoomsAD ? recA : simpleImgA
                    )}
                    {!noMeetingMode && imagesAD.length === 0 && hallwayAllowDefaultImage && (
                        <img
                            src={defaultABCD[0] || logo}
                            alt=""
                            className={`${classes.slideImageTF} `}
                        />
                    )}
                    {!noMeetingMode && imagesAD.length === 0 && !hallwayAllowDefaultImage && (
                        renderHallwayADMeetingRow(logo, 0)
                    )}
                </div>
            )}
        </div>
    ) : isDisplay11 ? (
        hasRowMeetings ? (
            meetingStackContent
        ) : (
            <div className={`${classes.slideTot} ${classes.singleImageTop}`}>
                <div
                    className={`${classes.boxT} ${classes.boxTFullHeight}`}
                >
                    <img
                        src={id11IdleImgSrc}
                        alt=""
                        className={classes.slideImageTF}
                    />
                </div>
            </div>
        )
    ) : isHolidayInnReception && hasRowMeetings ? (
        totemSingleTopMeetingModeId3 ? (
            <div className={`${classes.slideTot} ${classes.singleImageTop}`}>
                <div className={`${classes.boxT} ${classes.boxTFullHeight}`}>
                    <img
                        src={totemSingleTopImgSrc}
                        alt=""
                        className={classes.slideImageFixedHeight}
                    />
                </div>
                <hr className={classes.line} />
                <div className={classes.boxE}>
                    <div className={classes.hallwayMeetingRow}>
                        {meetingStackRows[0].node}
                    </div>
                </div>
            </div>
        ) : (
            meetingStackContent
        )
    ) : ts66;

    return (<Fragment>
        <div className={classes.totemWrapper}>
            <div className={classes.totemHeader}>
                {showTimeInHeader && (
                    <div className={classes.totemTime}>
                        <div className={classes.totemTimeA}>{actTime}</div>
                        <div className={classes.totemLineT}></div>
                        <div className={classes.totemTimeB}>{actDate}</div>
                    </div>
                )}
            </div>
            {content}
        </div>
    </Fragment>)
}

export default SlideshowTotem